export const DsLinkDefaultProps = {
    color: 'secondary',
    variant: 'bodyRegularSmall',
    underline: 'hover'
};
